import vars from '../_vars';

document.querySelector('.icon-burger').addEventListener('click', function () {
	document.body.classList.toggle('is-menu-open');
});

const menuItems = document.querySelectorAll('.main-menu li:not(.menu-item-has-children) > a');
menuItems.forEach(function (item) {
	item.addEventListener('click', function () {
		document.body.classList.remove('is-menu-open');
	});
});

function closeMobileMenu() {
	const subMenus = document.querySelectorAll('.main-menu .sub-menu, .footer-links .sub-menu');
	subMenus.forEach(function (subMenu) {
		subMenu.style.display = '';
	});
	if (window.innerWidth >= vars.bp.lg) {
		if (document.body.classList.contains('is-menu-open')) {
			document.querySelector('.icon-burger').click();
		}
	}
}

// Resize event handler
window.addEventListener('resize', function () {
	closeMobileMenu();
});

// Click event handler for toggling mobile submenus
const menuItemsWithChildren = document.querySelectorAll('.main-menu .menu-item-has-children, .footer-links .menu-item-has-children');
menuItemsWithChildren.forEach(function (item) {
	item.addEventListener('click', function (e) {
		const el = this,
			topEl = el.parentNode;
		if (window.innerWidth < vars.bp.lg) {
			e.stopPropagation();
			if (el.classList.contains('active')) {
				el.classList.remove('active');
			} else {
				topEl.querySelectorAll('.menu-item-has-children').forEach(function (menuItem) {
					menuItem.classList.remove('active');
				});
				el.classList.add('active');
			}
		}
	});
});
